export const BACK_LINK_ROW = 1;
export const BACK_LINK_COL = 8; // H

export const PARENT_SHEETS = {
  GENERAL_DISCLOSURES: "General Disclosures",
  PRINCIPLE_1: "PRINCIPLE 1",
  PRINCIPLE_2: "PRINCIPLE 2",
  PRINCIPLE_3: "PRINCIPLE 3",
  PRINCIPLE_4: "PRINCIPLE 4",
  PRINCIPLE_5: "PRINCIPLE 5",
  PRINCIPLE_6: "PRINCIPLE 6",
  PRINCIPLE_7: "PRINCIPLE 7",
  PRINCIPLE_8: "PRINCIPLE 8",
};

const LINK_FONT = {
  name: "Calibri",
  size: 11,
  color: { argb: "FF0563C1" },
  underline: true,
};

export function excelWorksheetName(name) {
  return String(name).substring(0, 31);
}

export function sheetBackLink(parentSheetName, cell = "D3") {
  const tabName = excelWorksheetName(parentSheetName).replace(/'/g, "''");
  return `#'${tabName}'!${cell}`;
}

export function addSheetBackLink(ws, parentSheetName, options = {}) {
  const row = options.row ?? BACK_LINK_ROW;
  const col = options.col ?? BACK_LINK_COL;
  const mergeEnd = options.mergeEnd ?? col;

  if (mergeEnd > col) {
    ws.mergeCells(row, col, row, mergeEnd);
  }

  const cell = ws.getCell(row, col);
  cell.value = {
    text: options.text ?? "Back",
    hyperlink: sheetBackLink(parentSheetName, options.parentCell ?? "D3"),
  };
  cell.font = LINK_FONT;
  cell.alignment = {
    horizontal: options.align ?? "right",
    vertical: "middle",
  };
}
